import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function PostDetail() {
  const { id } = useParams();
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);

  const posts = {
    1: {
      id: 1,
      title: 'Κλασικά Κουρέματα που Δεν Ξεπερνιούνται Ποτέ',
      image: '/images/1.jpg',
      date: '15 Ιανουαρίου 2025',
      author: 'Δημήτρης Παπαδόπουλος',
      content: `Τα κλασικά κουρέματα έχουν αντέξει στη δοκιμασία του χρόνου για έναν πολύ καλό λόγο - είναι διαχρονικά, κομψά και κολακεύουν όλους τους τύπους προσώπου. Σε αυτό το άρθρο, θα εξερευνήσουμε τα πιο εμβληματικά κλασικά κουρέματα που παραμένουν στη μόδα δεκαετίες μετά την πρώτη τους εμφάνιση.

Το κλασικό Fade είναι ίσως το πιο δημοφιλές κούρεμα όλων των εποχών. Χαρακτηρίζεται από μια σταδιακή μετάβαση από κοντά μαλλιά στα πλαϊνά και πίσω σε μακρύτερα μαλλιά στην κορυφή. Υπάρχουν διάφορες παραλλαγές - το low fade, mid fade και high fade - και καθένα προσφέρει διαφορετική αισθητική. Το fade είναι ιδανικό για άνδρες που θέλουν ένα καθαρό, επαγγελματικό look που μπορεί εύκολα να διαμορφωθεί για διαφορετικές περιστάσεις.

Το Undercut είναι άλλο ένα διαχρονικό στυλ που έχει γνωρίσει αναγέννηση τα τελευταία χρόνια. Χαρακτηρίζεται από πολύ κοντά ή ξυρισμένα πλαϊνά με σημαντικά μακρύτερα μαλλιά στην κορυφή. Αυτό το κούρεμα προσφέρει μεγάλη ευελιξία στο styling - μπορείτε να χτενίσετε τα μαλλιά πίσω για ένα κομψό look, να τα ρίξετε στο πλάι για πιο casual στυλ, ή ακόμα και να τα αφήσετε ελεύθερα για μια πιο edgy εμφάνιση.

Το Crew Cut είναι το απόλυτο κλασικό ανδρικό κούρεμα. Προέρχεται από τις στρατιωτικές βάσεις αλλά έχει εξελιχθεί σε ένα κομψό, εύκολο στη συντήρηση στυλ που ταιριάζει σε όλους. Τα μαλλιά είναι κοντά σε όλο το κεφάλι, με ελαφρώς μακρύτερα μαλλιά στην κορυφή. Είναι ιδανικό για άνδρες που προτιμούν low-maintenance κουρέματα χωρίς να θυσιάζουν το στυλ.

Το Side Part κούρεμα είναι η επιτομή της κλασικής κομψότητας. Χαρακτηρίζεται από μια καθαρή χωρίστρα στο πλάι και μαλλιά που χτενίζονται προσεκτικά. Αυτό το κούρεμα ήταν δημοφιλές στη δεκαετία του 1920 και παραμένει ένα αγαπημένο για άνδρες που θέλουν μια κλασική, επιπολιτισμένη εμφάνιση. Συνδυάζεται τέλεια με ένα καλό pomade ή wax για extra λάμψη και κράτημα.

Για να διατηρήσετε αυτά τα κλασικά κουρέματα, είναι σημαντικό να επισκέπτεστε τακτικά το barbershop σας - ιδανικά κάθε 3-4 εβδομάδες. Χρησιμοποιήστε ποιοτικά προϊόντα styling που ταιριάζουν στον τύπο των μαλλιών σας και μην ξεχνάτε να συμβουλεύεστε τον barber σας για συμβουλές συντήρησης. Ένα καλά συντηρημένο κλασικό κούρεμα μπορεί να σας κάνει να φαίνεστε κομψοί και γεμάτοι αυτοπεποίθηση σε κάθε περίσταση.`
    },
    2: {
      id: 2,
      title: 'Τέχνη της Ξυριστικής με Ξυράφι: Παραδοσιακή Μέθοδος',
      image: '/images/2.jpg',
      date: '12 Ιανουαρίου 2025',
      author: 'Νίκος Γεωργίου',
      content: `Το ξύρισμα με ίσιο ξυράφι είναι μια αρχαία τέχνη που χρονολογείται αιώνες πίσω. Παρόλο που οι σύγχρονες ξυριστικές μηχανές προσφέρουν ευκολία, τίποτα δεν συγκρίνεται με την εμπειρία και τα αποτελέσματα ενός επαγγελματικού ξυρίσματος με ξυράφι.

Η προετοιμασία είναι το κλειδί για ένα επιτυχημένο ξύρισμα με ξυράφι. Ξεκινήστε με ένα ζεστό ντους ή εφαρμόστε μια ζεστή πετσέτα στο πρόσωπο για 2-3 λεπτά. Αυτό θα ανοίξει τους πόρους και θα μαλακώσει τα μαλλιά της γενειάδας, καθιστώντας το ξύρισμα πιο εύκολο και λιγότερο επώδυνο. Στη συνέχεια, εφαρμόστε έναν ποιοτικό αφρό ξυρίσματος με πινέλο, δημιουργώντας ένα πλούσιο αφρό που θα προστατεύσει το δέρμα.

Η τεχνική του ξυρίσματος είναι κρίσιμη. Κρατήστε το ξυράφι σε γωνία 30 μοιρών σε σχέση με το δέρμα και ξυρίστε πάντα προς την κατεύθυνση ανάπτυξης των μαλλιών στην πρώτη διέλευση. Χρησιμοποιήστε το άλλο σας χέρι για να τεντώνετε το δέρμα, δημιουργώντας μια λεία επιφάνεια για το ξυράφι. Κινηθείτε με μικρές, ελεγχόμενες κινήσεις και αποφύγετε να πιέζετε πολύ το ξυράφι.

Για ένα extra λείο ξύρισμα, μπορείτε να κάνετε μια δεύτερη διέλευση. Εφαρμόστε ξανά αφρό και αυτή τη φορά ξυρίστε κάθετα ή ελαφρώς αντίθετα προς την ανάπτυξη των μαλλιών. Προσέξτε ιδιαίτερα στις ευαίσθητες περιοχές όπως το λαιμό και την περιοχή κάτω από τη μύτη.

Μετά το ξύρισμα, ξεπλύνετε το πρόσωπο με κρύο νερό για να κλείσετε τους πόρους και εφαρμόστε μια after-shave lotion ή balm. Αποφύγετε προϊόντα με πολύ αλκοόλη που μπορεί να ερεθίσουν το δέρμα. Ένα καλό after-shave θα ενυδατώσει και θα καθησυχάσει το δέρμα, αποτρέποντας ερεθισμούς και ξηρότητα.

Η συντήρηση του ξυραφιού σας είναι εξίσου σημαντική. Καθαρίστε το προσεκτικά μετά από κάθε χρήση, στεγνώστε το καλά και φυλάξτε το σε στεγνό μέρος. Ακονίζετε το ξυράφι σας τακτικά με λουρί δέρματος για να διατηρήσετε την κοπτερή του ακμή. Με τη σωστή φροντίδα, ένα καλό ξυράφι μπορεί να διαρκέσει μια ζωή.`
    },
    3: {
      id: 3,
      title: 'Περιποίηση Γενειάδας: Συμβουλές από Ειδικούς',
      image: '/images/3.jpg',
      date: '10 Ιανουαρίου 2025',
      author: 'Κώστας Ανδρέου',
      content: `Μια καλά περιποιημένη γενειάδα μπορεί να μεταμορφώσει την εμφάνιση ενός άνδρα, προσθέτοντας χαρακτήρα και ωριμότητα. Ωστόσο, η ανάπτυξη και συντήρηση μιας υγιούς, στιλάτης γενειάδας απαιτεί χρόνο, υπομονή και τη σωστή ρουτίνα περιποίησης.

Το πρώτο βήμα για μια όμορφη γενειάδα είναι η υπομονή κατά τη φάση ανάπτυξης. Τις πρώτες εβδομάδες, η γενειάδα μπορεί να φαίνεται ανώμαλη και να προκαλεί φαγούρα. Αντισταθείτε στην παρόρμηση να την ξυρίσετε. Χρησιμοποιήστε ένα ελαίο γενειάδας από νωρίς για να ενυδατώσετε τόσο τα μαλλιά όσο και το δέρμα από κάτω, μειώνοντας τη φαγούρα και προωθώντας την υγιή ανάπτυξη.

Το καθημερινό πλύσιμο είναι απαραίτητο για μια καθαρή γενειάδα. Χρησιμοποιήστε ένα ειδικό σαμπουάν γενειάδας 2-3 φορές την εβδομάδα και ξεπλύνετε με χλιαρό νερό. Αποφύγετε τα κανονικά σαμπουάν μαλλιών που μπορεί να είναι πολύ σκληρά και να αφαιρέσουν τα φυσικά έλαια. Μετά το πλύσιμο, στεγνώστε απαλά με μια πετσέτα και εφαρμόστε ελαίο ή balm γενειάδας.

Το χτένισμα είναι ζωτικής σημασίας για να διατηρήσετε τη γενειάδα σας τακτοποιημένη και χωρίς κόμπους. Χρησιμοποιήστε μια ξύλινη χτένα με πυκνά δόντια για να κατανείμετε τα φυσικά έλαια και τα προϊόντα περιποίησης ομοιόμορφα. Χτενίζετε πάντα προς την κατεύθυνση ανάπτυξης για να εκπαιδεύσετε τα μαλλιά να μένουν στη θέση τους.

Το κόψιμο και το shaping της γενειάδας πρέπει να γίνεται από επαγγελματία barber κάθε 4-6 εβδομάδες. Ωστόσο, μπορείτε να κάνετε μικρές διορθώσεις στο σπίτι με ένα ψαλίδι ή trimmer. Εστιάστε στη διατήρηση καθαρών γραμμών γύρω από τα μάγουλα και το λαιμό, και αφαιρέστε τυχόν άτακτα μαλλιά.

Η διατροφή παίζει σημαντικό ρόλο στην υγεία της γενειάδας. Καταναλώστε τροφές πλούσιες σε πρωτεΐνες, βιταμίνες B, και ψευδάργυρο για να προωθήσετε την ανάπτυξη των μαλλιών. Πίνετε άφθονο νερό και αποφύγετε το κάπνισμα, που μπορεί να επηρεάσει αρνητικά την ποιότητα των μαλλιών της γενειάδας. Με συνέπεια και τη σωστή φροντίδα, η γενειάδα σας θα γίνει το καλύτερο ανδρικό αξεσουάρ σας.`
    },
    4: {
      id: 4,
      title: 'Σύγχρονες Τάσεις στο Ανδρικό Hairstyling 2025',
      image: '/images/4.jpg',
      date: '8 Ιανουαρίου 2025',
      author: 'Γιάννης Μιχαηλίδης',
      content: `Το 2025 φέρνει μια συναρπαστική συλλογή από ανδρικά hairstyles που συνδυάζουν κλασική κομψότητα με σύγχρονη αισθητική. Από textured crops μέχρι longer styles, οι τάσεις αυτής της χρονιάς προσφέρουν κάτι για κάθε άνδρα, ανεξάρτητα από τον τύπο των μαλλιών ή το προσωπικό του στυλ.

Το Textured Crop εξακολουθεί να κυριαρχεί ως μια από τις πιο δημοφιλείς επιλογές. Αυτό το κούρεμα χαρακτηρίζεται από κοντά πλαϊνά και πίσω, με περισσότερο μήκος και texture στην κορυφή. Το μυστικό είναι η φυσική, ανακατεμένη υφή που δημιουργείται με τα σωστά προϊόντα styling. Είναι ιδανικό για άνδρες που θέλουν ένα σύγχρονο look που παραμένει εύκολο στη συντήρηση.

Τα μακρύτερα στυλ κάνουν δυναμική επιστροφή το 2025. Από shoulder-length locks μέχρι man buns, οι άνδρες αγκαλιάζουν πιο μακριά μήκη. Το κλειδί για να τα φοράτε σωστά είναι η καλή περιποίηση - τακτικά trims για να αφαιρείτε τις διχαλωτές άκρες, χρήση ενυδατικών προϊόντων και υπομονή κατά τη φάση ανάπτυξης.

Το Modern Pompadour παραμένει ένα αγαπημένο για άνδρες που θέλουν να κάνουν statement. Αυτή η σύγχρονη παραλλαγή του κλασικού pompadour συνδυάζει υψηλό volume στην κορυφή με καθαρά, κοντά πλαϊνά. Το styling απαιτεί ένα καλό blow dryer και ένα strong-hold pomade ή wax για να διατηρηθεί το ύψος και το σχήμα όλη την ημέρα.

Τα Curly Styles κερδίζουν έδαφος, καθώς όλο και περισσότεροι άνδρες με σγουρά μαλλιά αγκαλιάζουν τη φυσική τους υφή αντί να προσπαθούν να την ελέγξουν. Το κλειδί είναι τα σωστά προϊόντα - curl-defining creams και leave-in conditioners - και η σωστή τεχνική κοψίματος που να αναδεικνύει τις φυσικές μπούκλες.

Το Buzz Cut και άλλα ultra-short styles είναι perfect για άνδρες που προτιμούν minimal maintenance. Παρόλο που φαίνεται απλό, ένα καλά εκτελεσμένο buzz cut απαιτεί προσοχή στη λεπτομέρεια - καθαρές γραμμές, συμμετρία και το σωστό μήκος που να κολακεύει το σχήμα του κεφαλιού και του προσώπου.

Ανεξάρτητα από το στυλ που επιλέγετε, η ποιότητα του κοψίματος είναι κρίσιμη. Επισκεφθείτε έναν εξειδικευμένο barber που καταλαβαίνει τις τάσεις αλλά μπορεί επίσης να προσαρμόσει το look στο σχήμα του προσώπου σας, τον τύπο των μαλλιών σας και τον τρόπο ζωής σας.`
    },
    5: {
      id: 5,
      title: 'Προϊόντα Περιποίησης Μαλλιών που Πρέπει να Δοκιμάσετε',
      image: '/images/5.jpg',
      date: '5 Ιανουαρίου 2025',
      author: 'Παναγιώτης Σταύρου',
      content: `Η επιλογή των σωστών προϊόντων περιποίησης μαλλιών μπορεί να κάνει τη διαφορά μεταξύ ενός μέτριου και ενός εκπληκτικού look. Σε αυτόν τον οδηγό, θα εξερευνήσουμε τα απαραίτητα προϊόντα που κάθε άνδρας πρέπει να έχει στο οπλοστάσιό του και πώς να τα χρησιμοποιεί αποτελεσματικά.

Το Pomade είναι ένα κλασικό προϊόν styling που προσφέρει strong hold και high shine. Ιδανικό για slicked-back styles, pompadours και side parts. Υπάρχουν δύο κύριοι τύποι: water-based και oil-based. Τα water-based είναι ευκολότερα στο ξέπλυμα και προσφέρουν περισσότερη ευελιξία για restyling, ενώ τα oil-based παρέχουν ισχυρότερο κράτημα και περισσότερη λάμψη.

Η Hair Wax είναι ιδανική για textured, messy styles. Προσφέρει medium hold και matte finish, καθιστώντας την perfect για casual, φυσικούς looks. Εφαρμόστε μια μικρή ποσότητα σε στεγνά ή ελαφρώς νωπά μαλλιά και δουλέψτε την με τα δάχτυλά σας για να δημιουργήσετε texture και ορισμό.

Το Hair Clay έχει γίνει ιδιαίτερα δημοφιλές τα τελευταία χρόνια. Προσφέρει strong hold με matte finish και είναι excellent για δημιουργία volume και texture. Είναι ιδανικό για shorter styles όπως crops και quiffs. Το κλειδί είναι να εφαρμόζετε μια μικρή ποσότητα σε στεγνά μαλλιά και να το δουλεύετε σταδιακά.

Τα Hair Oils είναι απαραίτητα για την υγεία των μαλλιών. Ενυδατώνουν το τριχωτό, προσθέτουν λάμψη και μειώνουν το frizz. Εφαρμόστε λίγες σταγόνες σε νωπά μαλλιά μετά το πλύσιμο, εστιάζοντας στις άκρες. Για στεγνά μαλλιά, μπορείτε να εφαρμόσετε μια πολύ μικρή ποσότητα για extra shine.

Η Sea Salt Spray είναι perfect για δημιουργία beachy, textured looks. Ψεκάστε σε νωπά ή στεγνά μαλλιά και scrunch για να δημιουργήσετε φυσικούς κυματισμούς και volume. Είναι ιδανική για longer styles και για άνδρες με ίσια μαλλιά που θέλουν να προσθέσουν texture.

Ένα καλό Hair Tonic ή Leave-In Conditioner είναι απαραίτητο για τη διατήρηση των υγιών μαλλιών. Χρησιμοποιήστε το μετά το πλύσιμο για να ενυδατώσετε και να προστατεύσετε τα μαλλιά από ζημιές. Επιλέξτε προϊόντα με φυσικά συστατικά και αποφύγετε αυτά με σκληρές χημικές ουσίες.

Τέλος, μην υποτιμάτε τη σημασία ενός καλού σαμπουάν και conditioner. Επιλέξτε προϊόντα που ταιριάζουν στον τύπο των μαλλιών σας - moisturizing για ξηρά μαλλιά, volumizing για λεπτά μαλλιά, και clarifying για λιπαρά μαλλιά. Πλύνετε τα μαλλιά σας 2-3 φορές την εβδομάδα για να διατηρήσετε τα φυσικά έλαια.`
    }
  };

  const post = posts[id];

  const handleShare = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleFavorite = () => {
    setIsFavorite(!isFavorite);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  if (!post) {
    return (
      <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta name="description" content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming." />
      </Helmet>

      <div className="post-detail-container">
        <h2>Το άρθρο δεν βρέθηκε</h2>
        <Link to="/" className="btn btn-primary">Επιστροφή στην Αρχική</Link>
      </div>
    
    </>);
  }

  return (
    <div className="post-detail-container">
      <article className="post-detail">
        <img src={post.image} alt={post.title} className="post-detail-image" />
        <div className="post-detail-content">
          <h1 className="post-detail-title">{post.title}</h1>
          <div className="post-detail-meta">
            <span>{post.date}</span>
            <span>Συγγραφέας: {post.author}</span>
          </div>
          <div className="post-detail-text">
            {post.content.split('\n\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div className="post-detail-actions">
            <Link to="/" className="btn btn-primary">
              <FaShoppingCart /> Επιστροφή στα Άρθρα
            </Link>
            <button 
              className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
              onClick={handleFavorite}
            >
              <FaHeart /> {isFavorite ? 'Αποθηκευμένο' : 'Αποθήκευση'}
            </button>
          </div>
        </div>
      </article>

      {showNotification && (
        <div className="notification">
          {isFavorite ? 'Το άρθρο προστέθηκε στα αγαπημένα!' : 'Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη!'}
        </div>
      )}

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "image": `https://fapugo.com${post.image}`,
          "datePublished": post.date,
          "author": {
            "@type": "Person",
            "name": post.author
          },
          "publisher": {
            "@type": "Organization",
            "name": "Fapugo Barbershop",
            "logo": {
              "@type": "ImageObject",
              "url": "https://fapugo.com/images/logo.jpg"
            }
          },
          "description": post.content.substring(0, 200)
        })}
      </script>
    </div>
  );
}

export default PostDetail;